import {Component, Input} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {TranslocoPipe} from '@jsverse/transloco';
import {WaitlistPortalSlotDto} from '../../dtos/waitlist-portal-view.dto';
import {CustomDatePipe} from '../../../../shared/pipes/custom-date-pipe';

@Component({
  selector: 'app-slot-details',
  imports: [MatIconModule, TranslocoPipe, CustomDatePipe],
  templateUrl: './slot-details.component.html',
  styleUrl: './slot-details.component.scss'
})
export class SlotDetailsComponent {
  @Input() slot!: WaitlistPortalSlotDto;

  // whole minutes, which is how a practice quotes an appointment's length
  get durationMinutes(): number {
    return Math.round((new Date(this.slot.to).getTime() - new Date(this.slot.from).getTime()) / 60000);
  }
}
